$(function () {
	var www = $(window).width();
	var hhh = $(window).height();
	var preTop;
	var prePos = 0;
	var prePosTimer;

	const legArr = ["STEEL PIPE LEG", "L LEG", "SQUARE LEG", "FOLDING LOW LEG", "FOLDING LEG", "COMPASS WOOD LEG", "POLE LEG-S", "POLE LEG-C", "TOP CIRCLE", "TOP SQUARE"];
	const legArr2 = ["DESK & TABLE WOOD / ", "DESK & TABLE LINOLEUM / ", "DESK WOOD / ", "DESK LINOLEUM / ", "TABLE WOOD / ", "TABLE LINOLEUM / ", "aaaaa", "aaaaa", "aaaaa"];

	/*-------------------------------------
ポップアップ
-------------------------------------*/

	var speed = 300;

	var popupArg = {
		type: "inline",
		closeOnContentClick: false,
		closeBtnInside: true,
		mainClass: "mfp-img-mobile mfp-fade",
		closeOnBgClick: false,
		removalDelay: 300,

		gallery: {
			enabled: false,
		},
		callbacks: {
			beforeOpen: function () {
				preTop = $(window).scrollTop();
				//console.log(preTop);
			},
			open: function () {
				var clickedElement = $(this.currItem.el[0]);
				//console.log(clickedElement);

				var hash = clickedElement.data("hash");
				//console.log(hash);

				if (hash != undefined) {
					const tmpName = ".mfp-content #" + hash;
					//console.log(tmpName);

					const modalElement = $(".mfp-content #" + hash);
					var pos = modalElement.offset().top - $(".scrollBox").offset().top + 20;

					$(".scrollBox").animate({ scrollTop: pos }, 100, "swing");
				}

				$("html,body").addClass("hiddenBox");
				setTimeout(function () {
					$("html,body").addClass("hiddenBox");
				}, 100);

				$("html, body").animate({ scrollTop: preTop }, 0, "swing");

				$(".closeBtn").off("click.popupClose").on("click.popupClose", function () {
					$.magnificPopup.close();

					return false;
				});
			},
			beforeClose: function () {
				//$("html, body").animate({ scrollTop: preTop }, 0, "swing");
			},
			close: function () {
				$("html,body").removeClass("hiddenBox");

				setTimeout(function () {
					$("html, body").animate({ scrollTop: preTop }, 0, "swing");
				}, 10);
			},

			change: function () {
				//console.log('Content changed');
				$(".mfp-img").addClass("show");

				setTimeout(function () {
					$(".mfp-img").addClass("show");
					$(".mfp-figure").addClass("show");
				}, 10);
			},
		},
	};

	var popupArg3 = {
		items: { src: "#settingConfirm" },

		type: "inline",
		closeOnContentClick: false,
		closeBtnInside: false,
		mainClass: "mfp-img-mobile mfp-fade",
		closeOnBgClick: false,
		removalDelay: 300,

		gallery: {
			enabled: false,
		},
		callbacks: {
			beforeOpen: function () {
				preTop = $(window).scrollTop();
				//console.log(preTop);
			},
			open: function () {
				$("html,body").addClass("hiddenBox");
				setTimeout(function () {
					$("html,body").addClass("hiddenBox");
				}, 100);

				$("html, body").animate({ scrollTop: preTop }, 0, "swing");

				$(".closeBtn").off("click.popupClose").on("click.popupClose", function () {
					$.magnificPopup.close();

					return false;
				});
			},
			beforeClose: function () {
				//$("html, body").animate({ scrollTop: preTop }, 0, "swing");
			},
			close: function () {
				$("html,body").removeClass("hiddenBox");

				setTimeout(function () {
					$("html, body").animate({ scrollTop: preTop }, 0, "swing");
				}, 10);

				if (!consentFlg) {
					$("#setting-option").val("");
				}
			},

			change: function () {
				//console.log('Content changed');
				$(".mfp-img").addClass("show");

				setTimeout(function () {
					$(".mfp-img").addClass("show");
					$(".mfp-figure").addClass("show");
				}, 10);
			},
		},
	};

	/*
	var tmp = { items: { src: "#settingConfirm" } };
	//console.log(tmp);
	//console.log(popupArg);
	var popupArg2 = Object.assign(popupArg, tmp);
	//closeBtnInside: true,
	popupArg2["closeBtnInside"] = false;
	popupArg2["callbacks"]["close"] = function () {
		$("html,body").removeClass("hiddenBox");

		setTimeout(function () {
			$("html, body").animate({ scrollTop: preTop }, 0, "swing");
		}, 10);
		
		if(!consentFlg){
			$("#setting-option").val("");
		}
	};
	
	console.log(popupArg);
*/

	$(".popupInline").magnificPopup(popupArg);

	/*-------------------------------------
RESIZE
-------------------------------------*/

	$(window).on("resize", adjustResize);

	function adjustResize() {
		www = $(window).width();
		hhh = $(window).height();

		if (www > 719) {
			var g_wide = $(".productBox .productImgBox .galleryMain").width();
			//console.log(g_wide);

			$(".productBox .productImgBox .galleryThumbsAll .galleryThumbs").css("height", g_wide);
		}
	}
	adjustResize();

	/*-------------------------------------
DETAIL
-------------------------------------*/
	if ($(".galleryThumbs").length >= 1) {
		//prodauct-info.jsにもバリエーション連携の記述あり
		var tmpSlideNum = $(".galleryThumbs .swiper-container .swiper-slide").length;
		console.log(tmpSlideNum);

		var tmpSlideNumDefault = 2;

		if (tmpSlideNum % 2 == 1) {
			//奇数
			tmpSlideNumDefault = 2;
		} else if (tmpSlideNum % 2 == 0) {
			//偶数
			tmpSlideNumDefault = 2;
		}

		var galleryThumbs = new Swiper(".galleryThumbs .swiper-container", {
			loop: true,
			spaceBetween: 2,
			slidesPerView: 4.5,
			centeredSlidesBounds: true,
			direction: "horizontal",
			//mousewheel: true,
			//forceToAxis: true,

			// navigation: {
			// 	nextEl: ".slider__next",
			// 	prevEl: ".slider__prev",
			// },

			//freeMode: true,
			breakpoints: {
				// when window width is >= 719px
				719: {
					direction: "vertical",
					slidesPerView: "auto",
					spaceBetween: 2,
					slidesPerGroup: 1,
				},
			},

			on: {
				// slideChange: function () {
				// },
			},
		});

		var galleryMain = new Swiper(".galleryMain", {
			loop: true,
			watchOverflow: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			preventInteractionOnTransition: true,
			slideToClickedSlide: false,

			slidesPerView: 1,
			//direction: "vertical",
			//mousewheel: true,

			navigation: {
				nextEl: ".slider__next",
				prevEl: ".slider__prev",
			},

			effect: "fade",
			fadeEffect: {
				crossFade: true,
			},
			thumbs: {
				swiper: galleryThumbs,
			},

			breakpoints: {
				// when window width is >= 719px
				719: {
					//
				},
			},

			on: {
				init: function () {
					//console.log("swiper initialized");
					var lightbox = new PhotoSwipeLightbox({
						gallery: "#js-gallery",
						children: "a",
						pswpModule: PhotoSwipe,
					});
					lightbox.init();

					//prodauct-info.jsにもバリエーション連携の記述あり
					var targetImg = $('.galleryMain .swiper-slide[data-default="1"]');
					//console.log(targetImg);

					var tmpIndex = $(".galleryMain .swiper-slide").index(targetImg);
					//console.log(tmpIndex);

					var tmpSwiper = $(".galleryMain")[0]["swiper"];
					//console.log(tmpSwiper);
					tmpSwiper.slideTo(tmpIndex);
				},
				slideChangeTransitionEnd: function () {
					//
				},
			},
		});

		galleryMain.on("slideChangeTransitionStart", function () {
			//galleryThumbs.slideTo(galleryMain.activeIndex);
		});

		galleryThumbs.on("transitionStart", function () {
			//galleryMain.slideTo(galleryThumbs.activeIndex);
		});

		let isGalleryThumbsRunning = false;
		if (www > 719) {
			$(".galleryThumbs").on("wheel", function (event) {
				// 必要であればデフォルトのスクロール動作を無効化
				event.preventDefault();

				if (isGalleryThumbsRunning) return; // すでに実行中なら何もしない
				isGalleryThumbsRunning = true;

				// 垂直方向のスクロール量を取得 (上に回すとマイナス、下に回すとプラス)
				var deltaY = event.originalEvent.deltaY;

				if (deltaY > 0) {
					//console.log("下にスクロール");
					galleryMain.slideNext();
				} else {
					galleryMain.slidePrev();
				}

				setTimeout(function () {
					isGalleryThumbsRunning = false; // 200ms後に次の実行を許可
				}, 200);
			});
		}

		/////////////////////

		let isGalleryMainRunning = false;
		if (www > 719) {
/*
			$(".galleryMain").on("wheel", function (event) {
				// 必要であればデフォルトのスクロール動作を無効化
				event.preventDefault();

				if (isGalleryMainRunning) return; // すでに実行中なら何もしない
				isGalleryMainRunning = true;

				// 垂直方向のスクロール量を取得 (上に回すとマイナス、下に回すとプラス)
				var deltaY = event.originalEvent.deltaY;

				if (deltaY > 0) {
					//console.log("下にスクロール");
					galleryMain.slideNext();
				} else {
					galleryMain.slidePrev();
				}

				setTimeout(function () {
					isGalleryMainRunning = false; // 200ms後に次の実行を許可
				}, 200);
			});
*/
		}
	}

	/*-------------------------------------
カラースライダー
-------------------------------------*/

	// var colorSwiper = new Swiper(".colorSwiper", {
	// 	// Optional parameters
	// 	loop: false,
	// 	slidesPerView: "auto",
	// 	spaceBetween: 5,
	// 	centeredSlides: false,
	// 	breakpoints: {
	// 		// when window width is >= 719px
	// 		719: {
	// 			slidesPerView: "auto",
	// 			spaceBetween: 3,
	// 			centeredSlides: false,
	// 		},
	// 	},

	// 	navigation: {
	// 		nextEl: ".colorSwiperBtnBox .swiper-button-next",
	// 		prevEl: ".colorSwiperBtnBox .swiper-button-prev",
	// 	},

	// 	on: {
	// 		init: function () {
	// 			//天板カラー、脚カラー
	// 			var tmpSwiper = $(this["el"]);
	// 			var tmpBox = tmpSwiper.closest(".c-variant-picker-box");
	// 			//console.log(tmpBox);

	// 			tmpSwiper.find("input").click(function () {
	// 				var tmpVal = $(this).val();
	// 				//console.log(tmpVal);

	// 				tmpBox.find(".c-value").html(tmpVal);

	// 				//return false;
	// 			});
	// 		},
	// 	},
	// });

	/*-------------------------------------
NAME
-------------------------------------*/

	if ($(".name").length >= 1) {
		var tmp = $(".name");
		var ttl = tmp.data("name");
		var deskTableMode = "";

		if (ttl.indexOf("DESK") != -1 || ttl.indexOf("TABLE") != -1) {
			//console.log(ttl);

			//SEMIORDERを含む場合の処理
			for (var i = 0; i < legArr2.length; i++) {
				var word = legArr2[i];
				var word2 = ttl.replace(" / ", "<br>");
				//console.log(word);
				//console.log(word2);

				if (ttl.indexOf(word) != -1) {
					//var ttl2 = ttl.replace(word, "");
					tmp.data("name", word2);
					tmp.html(word2);
					//tmp.prev(".name").text(word2);

					break;
				}
			}
		}

		var w_min = 0;
		var w_max = 0;
		var h_min = 0;
		var h_max = 0;

		var w_min2 = 0;
		var w_max2 = 0;
		var h_min2 = 0;
		var h_max2 = 0;

		var kaku_min = 0;
		var ph_min = 0;

		checkSize();
		//console.log(w_min2);

		//if (ttl.indexOf("DESK & TABLE") != -1) {
		if (w_min2 != "") {
			//console.log("changeMainTtl");
			changeMainTtl();

			$(".itemTabList li.mode").click(function () {
				var tmpBtn = $(this);
				deskTableMode = tmpBtn.text();
				checkMode(deskTableMode);

				$(".itemTabList li.mode").removeClass("active");
				tmpBtn.addClass("active");
				checkSize();
				changeMainTtl();

				return false;
			});
		} else {
			//console.log("changeMainTtl-no");
			$(".itemTabDesp").hide();
			$(".itemTabListDeskTable").hide();
		}
	}

	function checkSize() {
		w_min = $(".itemTabList li.active").data("w_min");
		w_max = $(".itemTabList li.active").data("w_max");
		h_min = $(".itemTabList li.active").data("h_min");
		h_max = $(".itemTabList li.active").data("h_max");

		w_min2 = $(".itemTabList li.table").data("w_min");
		w_max2 = $(".itemTabList li.table").data("w_max");
		h_min2 = $(".itemTabList li.table").data("h_min");
		h_max2 = $(".itemTabList li.table").data("h_max");

		kaku_min = $(".itemTabList li.table").data("kaku_min");
		ph_min = $(".itemTabList li.table").data("ph_min");

		$("#w_min").text(w_min);
		$("#w_max").text(w_max);
		$("#h_min").text(h_min);
		$("#h_max").text(h_max);

		$("#sizeW").attr("min", w_min);
		$("#sizeW").attr("max", w_max);
		$("#sizeH").attr("min", h_min);
		$("#sizeH").attr("max", h_max);

		$('.sizeBox input[type="number"]').trigger("change");
	}

	function changeMainTtl() {
		var mode = "";

		mode = $(".itemTabList li.active").text();
		//console.log(mode);

		var ttl = $(".name").data("name");
		var ttl2 = ttl.replace("DESK & TABLE", mode);
		//var ttl2 = ttl2.replace("DESK &amp; TABLE", mode);
		//console.log(ttl);
		//console.log(ttl2);
		$(".name").html(ttl2);
	}

	function checkMode(mode = "DESK") {
		//console.log(mode);

		if (mode == "DESK") {
			$("#shape2Box").stop().fadeOut(100);
			$("#shape3Box").stop().fadeOut(100);
			$("#fieldHole").stop().fadeIn(100);
		} else if (mode == "TABLE") {
			$("#shape2Box").stop().fadeIn(100);
			$("#shape3Box").stop().fadeIn(100);
			$("#fieldHole").stop().fadeOut(100);
		}

		//選んだタイプ（DESK / TABLE）を注文データ（properties[タイプ]）に入れる
		if (mode == "DESK" || mode == "TABLE") {
			$("#deskTableType").val(mode);
		}

		//モード切替時は小口形状・配線孔を初期値に戻す（画面の表示とGPOの値を両方そろえる）
		//※GPOのID（radio-1_1など）は商品ごとに順番が変わるため使わない。組立設置は変更しない
		$("#shape1").prop("checked", true).trigger("click");
		$(".shape-box .c-value").html("通常面");
		$("#hole-option").val("0").trigger("change");
		calPrice();

		var tmpName = $(".name").data("name");
		//console.log(tmpName);

		if (kaku_min != "" || ph_min != "" || tmpName == "TABLE WOOD<br>COMPASS WOOD LEG" || tmpName == "TABLE LINOLEUM<br>COMPASS WOOD LEG" || tmpName == "DESK & TABLE WOOD<br>TABLE TOP SQUARE" || tmpName == "DESK & TABLE LINOLEUM<br>TABLE TOP SQUARE") {
			//console.log("aaaa");

			$("#shape2Box").stop().fadeIn(100);
			$("#shape3Box").stop().fadeIn(100);
		}
	}
	checkMode();

	/*-------------------------------------
天板サイズ
-------------------------------------*/
	//focusout change input keyup paste 99999
	$('.sizeBox input[type="number"]').on("change", function () {
		if (this.max) this.value = Math.min(parseInt(this.max), parseInt(this.value) || 0);
		if (this.min) this.value = Math.max(parseInt(this.min), parseInt(this.value) || 0);
	});

	$(".sizeCostInput").on("change", function () {
		//console.log(this.value);

		if (this.value >= 90) {
			$("#boardSize2").prop("checked", true);
			var tmpLabel = $("#boardSize2").data("label");
		} else {
			$("#boardSize1").prop("checked", true);
			var tmpLabel = $("#boardSize1").data("label");
		}
		//console.log(tmpLabel);

		//ダミーのinput、Globo Product Optionを正しく選択する
		var target = $(".gpo-container").find('input[value="' + tmpLabel + '"]');
		var targetID = target.attr("id");
		//console.log(targetID);
		var targetID2 = "#" + targetID;

		$(targetID2).trigger("click");

		target.prop("checked", true);

		calPrice();
	});

	if ($(".sizeCostInput").length >= 1) {
		var tmpValue = $(".sizeCostInput")[0].value;
		//console.log(tmpValue);

		if (tmpValue >= 90) {
			$("#boardSize2").prop("checked", true);
			var tmpLabel = $("#boardSize2").data("label");
		} else {
			$("#boardSize1").prop("checked", true);
			var tmpLabel = $("#boardSize1").data("label");
		}

		$(".sizeCostInput").trigger("change");

		const targetNode = document.getElementById("productBox");
		const config = { attributes: false, childList: true, subtree: true };
		const handleMutation = (mutationsList, observer) => {
			mutationsList.forEach((mutation) => {
				// 変更に対する処理
				//console.log("DOMが変更されました:", mutation);
			});

			//console.log(tmpLabel);

			//ダミーのinput、Globo Product Optionを正しく選択する
			var target = $(".gpo-container").find('input[value="' + tmpLabel + '"]');
			var targetID = target.attr("id");
			//console.log(targetID);
			var targetID2 = "#" + targetID;

			$(targetID2).trigger("click");

			target.prop("checked", true);

			calPrice();

			if (targetID != undefined) {
				observer.disconnect();
			}
		};
		// コールバック関数に結びつけられたオブザーバーのインスタンスを生成
		const observer = new MutationObserver(handleMutation);
		// 対象ノードの設定された変更の監視を開始
		observer.observe(targetNode, config);
	}

	/*-------------------------------------
小口形状
-------------------------------------*/
	//ダミーのinput、Globo Product Optionを正しく選択する
	$(".shapeList li .shapeRadio").click(function () {
		var tmpVal = $(this).val();
		var tmpLabel = $(this).data("label");
		var tmpBox = $(this).closest(".c-variant-picker-box");
		//console.log(tmpVal);

		tmpBox.find(".c-value").html(tmpVal);

		var target = $(".gpo-container").find('input[value="' + tmpLabel + '"]');
		var targetID = target.attr("id");
		console.log(targetID);
		var targetID2 = "#" + targetID;

		$(targetID2).trigger("click");

		target.prop("checked", true);

		calPrice();

		//return false;
	});

	/*-------------------------------------
配線孔
-------------------------------------*/

	$("#hole-option").change(function () {
		var index = $(this).val();
		//console.log(index);

		if (index == 0) {
			$('input[name="properties[配線孔穴位置]"]').prop("checked", false);
			$("#js-hole-description").hide();
		} else {
			$("#js-hole-description").show();
		}

		var target = $(".gpo-container").find('input[name="配線孔オプション"]').eq(index);
		var targetID = target.attr("id");
		console.log(targetID);
		var targetID2 = "#" + targetID;

		$(targetID2).trigger("click");

		//var label = $(".gpo-choicelist").find('label[for=" + targetID + "]');
		//console.log(label);

		target.prop("checked", true);

		calPrice();
	});

	/*-------------------------------------
組立設置
-------------------------------------*/

	var consentFlg = false;

	var priceItem = $(".price-item");
	$.each(priceItem, function (index, el) {
		var tmpPrice = $(el).text();
		tmpPrice = $.trim(tmpPrice);
		$(el).data("origin-price", tmpPrice);

		//console.log($(el).data("origin-price"));
	});

	function calPrice() {
		setTimeout(function () {
			var addOnsObj = $(".gpo-label .addOn");
			//セール時は定価（取り消し線）と販売価格の両方に加算
			//対象は商品詳細のメイン価格のみ（一覧カードや関連商品の価格「¥3,300〜¥16,500」などは書き換えない）
			var priceObj = $(".c-product-price-delivery-fee").find(".price-item--regular, .price-item--sale");

			var addOnsPrice = 0;

			$.each(addOnsObj, function (index, el) {
				var tmpPrice = $(el).text();
				tmpPrice = $.trim(tmpPrice);

				if (tmpPrice != "") {
					//数字以外（¥ , 括弧など）を除去
					tmpPrice = tmpPrice.replace(/[^0-9]/g, "");
					tmpPrice = Number(tmpPrice);
					//console.log(tmpPrice);
					addOnsPrice = addOnsPrice + tmpPrice;
				}
			});

			//console.log(addOnsPrice);

			if ($.isNumeric(addOnsPrice)) {
				//console.log(priceObj);
				$.each(priceObj, function (index, el) {
					//var tmpPrice = $(el).text();
					var tmpPrice = $(el).data("origin-price");
					//バリアント切替で価格表示が描き直された場合は、その時点の表示（オプション加算前の価格）を基準として保存
					if (tmpPrice === undefined) {
						tmpPrice = $.trim($(el).text());
						$(el).data("origin-price", tmpPrice);
					}
					tmpPrice = $.trim(tmpPrice);

					if (tmpPrice != "") {
						tmpPrice = tmpPrice.replace(/[^0-9]/g, "");
						tmpPrice = Number(tmpPrice) + addOnsPrice;
						tmpPrice = tmpPrice.toLocaleString();

						var tmpPriceText = "¥" + tmpPrice;
						$(el).text(tmpPriceText);
					}

					//console.log(tmpPrice);
				});
			}
		}, 100);
	}

	//バリアント（カラー）切替後も、選択中オプションの料金を価格表示に反映する
	if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
		subscribe(PUB_SUB_EVENTS.variantChange, function () {
			calPrice();
		});
	}

	//GPOの料金表示（.gpo-label）が書き換わったら価格を再計算する
	//（GPOはバリアント切替やオプション選択のあと非同期に再描画するため、タイミングに左右されないようにする）
	var gpoPriceTimer;
	var productBoxEl = document.getElementById("productBox");
	if (productBoxEl && window.MutationObserver) {
		new MutationObserver(function (mutations) {
			var isGpo = mutations.some(function (m) {
				var el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
				if (el && el.closest && el.closest(".gpo-container")) return true;
				return Array.prototype.some.call(m.addedNodes, function (n) {
					return n.nodeType === 1 && (n.matches(".gpo-container, .gpo-label, .addOn") || !!n.querySelector(".gpo-label"));
				});
			});

			if (isGpo) {
				clearTimeout(gpoPriceTimer);
				gpoPriceTimer = setTimeout(calPrice, 50);
			}
		}).observe(productBoxEl, { childList: true, subtree: true, characterData: true });
	}

	if ($("#settingField").length >= 1) {
		var settingArea1 = ["北海道", "青森県", "岩手県", "秋田県", "鳥取県", "島根県", "岡山県", "広島県", "山口県", "徳島県", "香川県", "愛媛県", "高知県", "福岡県", "佐賀県", "長崎県", "大分県", "熊本県", "宮城県", "鹿児島県"];
		var settingArea2 = ["宮城県", "山形県", "福島県", "茨城県", "栃木県", "群馬県", "埼玉県", "千葉県", "東京都", "神奈川県", "山梨県", "岐阜県", "静岡県", "愛知県", "三重県", "新潟県", "長野県", "富山県", "石川県", "福井県", "滋賀県", "京都府", "大阪府", "兵庫県", "奈良県", "和歌山"];
		var settingArea3 = ["沖縄県"];

		$("#setting-option").change(function () {
			var pref = $(this).val();
			//console.log(pref);

			if (pref != "") {
				//console.log(popupArg2);
				//$.magnificPopup.open(popupArg2);
				$.magnificPopup.open(popupArg3);
				$("button.mfp-close").hide();
			}

			if (pref == "") {
				var target = $(".gpo-container").find('input[name="組立設置"]').eq(0);
				var targetID = target.attr("id");
				//console.log(targetID);
				var targetID2 = "#" + targetID;

				$(targetID2).trigger("click");

				target.prop("checked", true);

				$("#settingFieldPrice").text("");
			}

			calPrice();
		});

		$("#consentBtn").click(function () {
			var tmp = $("#consentCheckbox:checked").val();
			//console.log(tmp);

			if (tmp == "同意する") {
				$.magnificPopup.close();
				$("#consentLabel").removeClass("error");

				var selectPref = $("#setting-option").val();
				var area = "";
				if ($.inArray(selectPref, settingArea1) !== -1) {
					area = "area1";
				} else if ($.inArray(selectPref, settingArea2) !== -1) {
					area = "area2";
				} else if ($.inArray(selectPref, settingArea3) !== -1) {
					area = "area3";
				}
				//console.log(selectPref);
				//console.log(area);
				var index = 0;

				if (area == "area1") {
					index = 1;
					$("#settingFieldPrice").text("北海道・北東北・中国・四国・九州(+ ¥8,150)");
				} else if (area == "area2") {
					index = 2;
					$("#settingFieldPrice").text("南東北・関東・東海・信越・北陸・関西(+ ¥9,860)");
				} else if (area == "area3") {
					index = 3;
					$("#settingFieldPrice").text("沖縄(+ ¥6,700)");
				} else {
					$("#settingFieldPrice").text("");
				}

				var target = $(".gpo-container").find('input[name="組立設置"]').eq(index);
				var targetID = target.attr("id");
				//console.log(targetID);
				var targetID2 = "#" + targetID;

				$(targetID2).trigger("click");

				target.prop("checked", true);

				consentFlg = true;
			} else {
				$("#consentLabel").addClass("error");
			}

			calPrice();

			return false;
		});

		$("#consentNgBtn").click(function () {
			$.magnificPopup.close();
			$("#consentCheckbox").removeAttr("checked").prop("checked", false).change();
			$("#setting-option").prop("selected", false);
			$("#setting-option").val("");
			$("#setting-option").trigger("change");

			return false;
		});
	} else {
		$("#detailInfoList-setting").hide();
	}

	if ($("#detailInfoList-setting-only").length >= 1) {
		//$.magnificPopup.open(popupArg2);
		//$.magnificPopup.open(popupArg3);
		//$("button.mfp-close").hide();

		$(".product-form__submit").addClass("disable");
		//$(".product-form__submit span").text("開梱設置サービス・２名配送に同意してください");

		$("#consentBtn").click(function () {
			var tmp = $("#consentCheckbox:checked").val();
			//console.log(tmp);

			if (tmp == "同意する") {
				$.magnificPopup.close();
				$("#consentLabel").removeClass("error");

				$(".product-form__submit").removeClass("disable");
				//$(".product-form__submit span").text("カートに追加する");

				$("#settingServiceBtn").hide();

				consentFlg = true;
			} else {
				$("#consentLabel").addClass("error");
			}

			return false;
		});

		$("#consentNgBtn").click(function () {
			$.magnificPopup.close();

			return false;
		});

		$("#settingServiceBtn").click(function () {
			//$.magnificPopup.open(popupArg2);
			$.magnificPopup.open(popupArg3);
			$("button.mfp-close").hide();

			return false;
		});
	}

	/*-------------------------------------
オーダーフレーム
-------------------------------------*/
	if ($("#orderFrameSizeField").length >= 1) {
		const targetNode = document.getElementById("productBox");
		const config = { attributes: false, childList: true, subtree: true };
		const handleMutation = (mutationsList, observer) => {
			mutationsList.forEach((mutation) => {
				// 変更に対する処理
				//console.log("DOMが変更されました:", mutation);
			});

			calOrderFrame();
			sizeFieldHideReal();

			setDefaultKeyHole();

			//console.log("DOMが変更されました");
			//console.log(prePos);
			$("html, body").animate({ scrollTop: prePos }, 0, "swing");

			prePosTimer = setTimeout(function () {
				$("html, body").animate({ scrollTop: prePos }, 0, "swing");
			}, 300);
		};
		// コールバック関数に結びつけられたオブザーバーのインスタンスを生成
		const observer = new MutationObserver(handleMutation);
		// 対象ノードの設定された変更の監視を開始
		observer.observe(targetNode, config);

		$(window).on("scroll", function () {
			prePos = $(window).scrollTop();
			clearTimeout(prePosTimer);
		});

		function sizeFieldHide() {
			sizeFieldHideReal();

			setTimeout(function () {
				sizeFieldHideReal();
			}, 300);

			/*
			setTimeout(function () {
				sizeFieldHideReal();
			}, 1000);

			setTimeout(function () {
				sizeFieldHideReal();
			}, 2000);
*/
		}
		sizeFieldHide();

		function sizeFieldHideReal() {
			var sizeField = $(".c-label");
			var sizeFieldBox;

			$.each(sizeField, function (index, el) {
				var sizeFieldName = $(el).text();

				if (sizeFieldName == "サイズ規格内") {
					//console.log(sizeFieldName);
					sizeFieldBox = $(el).parent(".product-form__input");
					sizeFieldBox.hide();
				}
				if (sizeFieldName == "フレーム幅") {
					//console.log(sizeFieldName);
					var tmpHtml = 'フレーム幅<span href="#orderFrame" class="popupInlineFrame question" data-hash="step01">?</span>';
					$(el).html(tmpHtml);

					$(".popupInlineFrame").magnificPopup(popupArg);

					sizeFieldBox = $(el).parent(".product-form__input");
					var labels = sizeFieldBox.find("label");

					labels.off("click");
					labels.click(function () {
						prePos = $(window).scrollTop();
					});
				}
			});

			$(".colorSwiper input").off("click");
			$(".colorSwiper input").click(function () {
				//console.log("colorSwiper");
				sizeFieldHide();

				prePos = $(window).scrollTop();
			});
		}

		$(".frameChoiceBtn").click(function () {
			var target = $(this).data("frame-type");

			if (target == "frameType1") {
				$("#frameType1").addClass("active");
				$("#frameType2").removeClass("active");
			} else if (target == "frameType2") {
				$("#frameType1").removeClass("active");
				$("#frameType2").addClass("active");
			}

			activeForm();

			calOrderFrame();
		});

		function activeForm() {
			var tmpVal = $("input.frameChoiceBtn:checked").val();

			var target = "";
			if (tmpVal == "あり") {
				target = "frameType1";
				$("#frameType1").addClass("active");
				$("#frameType2").removeClass("active");
			} else {
				target = "frameType2";
				$("#frameType1").removeClass("active");
				$("#frameType2").addClass("active");
			}

			var tmpTargetOn = "";
			var tmpTargetOff = "";

			if (target == "frameType1") {
				tmpTargetOn = "frameType1";
				tmpTargetOff = "frameType2";
			} else if (target == "frameType2") {
				tmpTargetOn = "frameType2";
				tmpTargetOff = "frameType1";
			}

			$.each($("#" + tmpTargetOn + " input"), function (index, el) {
				var tmpForm = $(el).data("form");
				//console.log(tmpForm);
				$(el).attr("form", tmpForm);
			});

			$.each($("#" + tmpTargetOff + " input"), function (index, el) {
				var tmpForm = $(el).data("form");
				//console.log(tmpForm);
				$(el).attr("form", "");
			});

			sizeFieldHide();
		}
		activeForm();

		/*-------------------------------------
キーホール
-------------------------------------*/

		$("#key-hole-option").change(function () {
			prePos = $(window).scrollTop();

			var index = $(this).val();

			var target = $(".gpo-container").find('input[name="キーホール"]').eq(index);
			target.trigger("click");

			target.prop("checked", true);

			//calPrice();
		});

		var firstKeyHoteFlg = true;
		var firstKeyHoteTimer = true;

		function setDefaultKeyHole() {
			var index = $("#key-hole-option").val();
			//console.log(index);

			if (firstKeyHoteFlg) {
				var targetZero = $(".gpo-container").find('input[name="キーホール"]').eq(0);
				targetZero.trigger("click");
				targetZero.prop("checked", true);

				firstKeyHoteFlg = false;
			}

			clearTimeout(firstKeyHoteTimer);
			firstKeyHoteTimer = setTimeout(function () {
				var target = $(".gpo-container").find('input[name="キーホール"]').eq(index);
				target.trigger("click");
				target.prop("checked", true);
			}, 1000);
			//calPrice();
		}

		/*-------------------------------------
吊り下げ紐：無料になったので、使わない
-------------------------------------*/

		$("#string-option").change(function () {
			var index = $(this).val();

			var target = $(".gpo-container").find('input[name="吊り下げ紐"]').eq(index);
			var targetID = target.attr("id");
			//console.log(targetID);
			var targetID2 = "#" + targetID;

			$(targetID2).trigger("click");

			target.prop("checked", true);

			calPrice();
		});

		$('.numberTate,.numberYoko,input[name="properties[フレーム被せ分：上下]"],input[name="properties[フレーム被せ分：左右]"]').change(function () {
			var tmpMax = $(this).attr("max");
			var tmpMin = $(this).attr("min");
			var tmpVal = $(this).val();

			//console.log(tmpMax);
			//console.log(tmpMin);
			//console.log(tmpVal);

			tmpMax = toHalfWidth(tmpMax);
			tmpMin = toHalfWidth(tmpMin);
			tmpVal = toHalfWidth(tmpVal);

			tmpMax = parseInt(tmpMax);
			tmpMin = parseInt(tmpMin);
			tmpVal = parseInt(tmpVal);

			if (tmpVal > tmpMax) {
				tmpVal = tmpMax;
			} else if (tmpVal < tmpMin) {
				tmpVal = tmpMin;
			}

			$(this).val(tmpVal);
		});

		$("#numberTate1").focusout(function () {
			prePos = $(window).scrollTop();
			//console.log("focusout");
			//console.log(prePos);

			prePosTimer = setTimeout(function () {
				$("html, body").animate({ scrollTop: prePos }, 0, "swing");
				$("#numberYoko1").focus();
			}, 30);

			prePosTimer = setTimeout(function () {
				$("html, body").animate({ scrollTop: prePos }, 0, "swing");
				$("#numberYoko1").focus();
			}, 300);
		});

		$("#numberTate2").focusout(function () {
			prePos = $(window).scrollTop();

			prePosTimer = setTimeout(function () {
				$("html, body").animate({ scrollTop: prePos }, 0, "swing");
				$("#numberYoko2").focus();
			}, 30);

			prePosTimer = setTimeout(function () {
				$("html, body").animate({ scrollTop: prePos }, 0, "swing");
				$("#numberYoko2").focus();
			}, 300);
		});

		$("#numberTateMargin1").focusout(function () {
			prePos = $(window).scrollTop();

			prePosTimer = setTimeout(function () {
				$("html, body").animate({ scrollTop: prePos }, 0, "swing");
				$("#numberTateYoko1").focus();
			}, 30);

			prePosTimer = setTimeout(function () {
				$("html, body").animate({ scrollTop: prePos }, 0, "swing");
				$("#numberTateYoko1").focus();
			}, 300);
		});

		$('.numberTate,.numberYoko,input[name="properties[余白]"],input[name="properties[フレーム被せ分：上下]"],input[name="properties[フレーム被せ分：左右]"]').change(function () {
			prePos = $(window).scrollTop();

			calOrderFrame();
		});

		function toHalfWidth(str) {
			// 全角英数字を半角に変換
			str = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
				return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
			});
			return str;
		}

		calPrice();
		calOrderFrame();

		function calOrderFrame() {
			//var frame_width = $('input[name="フレーム幅-2\n"]:checked').data("value");
			var frame_width = "30mm";

			var sizeField = $(".c-label");
			var sizeFieldBox;

			$.each(sizeField, function (index, el) {
				var sizeFieldName = $(el).text();

				//if (sizeFieldName == "フレーム幅") {
				if (sizeFieldName.indexOf("フレーム幅") !== -1) {
					//console.log(sizeFieldName);
					sizeFieldBox = $(el).parent(".product-form__input");

					frame_width = sizeFieldBox.find("input:checked").val();
					//console.log(frame_width);
					frame_width = frame_width.replace("mm", "");
					frame_width = parseInt(frame_width);
					//console.log(frame_width);
				}
			});

			var frame_margin = $('input[name="properties[余白]"]:checked').data("value");
			//console.log(frame_margin);

			var tate = 0;
			var yoko = 0;
			var totalTate = 0;
			var totalYoko = 0;

			if (frame_margin == 0) {
				//余白あり
				tate = $('input[name="properties[窓寸法：タテ幅]"]').val();
				yoko = $('input[name="properties[窓寸法：ヨコ幅]"]').val();
				tate = parseInt(tate);
				yoko = parseInt(yoko);

				totalTate = tate + frame_width * 2;
				totalYoko = yoko + frame_width * 2;
			} else {
				//余白なし
				tate = $('input[name="properties[額装物サイズ：タテ幅]"]').val();
				yoko = $('input[name="properties[額装物サイズ：ヨコ幅]"]').val();
				tate = parseInt(tate);
				yoko = parseInt(yoko);

				var numberTateMargin1 = $("#numberTateMargin1").val();
				var numberTateYoko1 = $("#numberTateYoko1").val();

				totalTate = tate + (6 - numberTateMargin1) * 2 + (frame_width - 6) * 2;
				totalYoko = yoko + (6 - numberTateYoko1) * 2 + (frame_width - 6) * 2;
			}

			var msg = totalTate + " x " + totalYoko;
			//console.log(msg);

			$("#orderFrameSize").val(msg);

			var menseki = (totalTate * totalYoko) / 1000000;
			var weight = menseki * 11.161161;
			//weight = Math.round(weight);
			weight = weight.toFixed(2);

			$("#orderFrameWeight").val(weight);

			var tatalLong = totalTate + totalYoko;
			var deliveryType = "";
			//var sizeFieldBoxInput = sizeFieldBox.find("input");
			//console.log(sizeFieldBoxInput);

			if (tatalLong <= 600) {
				deliveryType = "B";
				var tmpInputName = "input[value='EPレコード']";
			} else if (tatalLong <= 870) {
				deliveryType = "C";
				var tmpInputName = "input[value='LPレコード']";
			} else if (tatalLong <= 957) {
				deliveryType = "C";
				var tmpInputName = "input[value='A3']";
			} else if (tatalLong <= 1254) {
				deliveryType = "E";
				var tmpInputName = "input[value='A2']";
			} else if (tatalLong <= 1440) {
				deliveryType = "E";
				var tmpInputName = "input[value='B2']";
			} else if (tatalLong <= 1675) {
				deliveryType = "E";
				var tmpInputName = "input[value='A1']";
			} else if (tatalLong <= 1998) {
				deliveryType = "I";
				var tmpInputName = "input[value='B1']";
			} else if (tatalLong <= 2270) {
				deliveryType = "I";
				var tmpInputName = "input[value='A0']";
			} else if (tatalLong <= 2640) {
				//2500
				deliveryType = "K";
				var tmpInputName = "input[value='B0']";
			} else {
				deliveryType = "K";
				var tmpInputName = "input[value='B0']";
			}

			//var tmpInput = sizeFieldBox.find(tmpInputName);
			var tmpInput = $(".product-form__input").find(tmpInputName);
			tmpInput.next("label").trigger("click");
			//tmpInput[0].click();

			setTimeout(function () {
				//tmpInput = sizeFieldBox.find(tmpInputName);
				tmpInput = $(".product-form__input").find(tmpInputName);
				tmpInput.next("label").trigger("click");
			}, 1000);

			//console.log("---------------");
			//console.log(tmpInput[0]);
			//console.log(tmpInput.next("label"));

			//console.log(tatalLong);
			//console.log(deliveryType);

			$("#orderDeliveryType").val(deliveryType);
		}
	}

	/*-------------------------------------
ポップアップ黒、ミニ
-------------------------------------*/
	if ($(".popupInlineTop").length >= 1) {
		$(".popupInlineTop").magnificPopup({
			type: "inline",
			closeOnContentClick: true,
			closeBtnInside: true,
			mainClass: "mfp-img-mobile mfp-fade mfp-no-bg",
			closeOnBgClick: true,
			removalDelay: 300,

			gallery: {
				enabled: false,
			},
			callbacks: {
				beforeOpen: function () {
					preTop = $(window).scrollTop();
					//console.log(preTop);
				},
				open: function () {
					$("html,body").addClass("hiddenBox");
					setTimeout(function () {
						$("html,body").addClass("hiddenBox");
					}, 100);

					$("html, body").animate({ scrollTop: preTop }, 0, "swing");

					$(".closeBtn").off("click.popupClose").on("click.popupClose", function () {
						$.magnificPopup.close();

						return false;
					});
				},
				beforeClose: function () {
					//$("html, body").animate({ scrollTop: preTop }, 0, "swing");
				},
				close: function () {
					$("html,body").removeClass("hiddenBox");

					setTimeout(function () {
						$("html, body").animate({ scrollTop: preTop }, 0, "swing");
					}, 10);
				},

				change: function () {
					//console.log('Content changed');
					$(".mfp-img").addClass("show");

					setTimeout(function () {
						$(".mfp-img").addClass("show");
						$(".mfp-figure").addClass("show");
					}, 10);
				},
			},
		});

		$(".popupInlineTop").magnificPopup("open");
	}
});
